import topTitle from '@/views/template/components/title';
export default {
  components: {
    topTitle
  },
  props: {
    themeColor: {
      type: String,
      default: ''
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  watch: {
    styleObj: {
      handler(val) {
        console.log(4333333);
      },
      deep: true
    }
  },
  data() {
    return {
      list: [{
        name: '保险信息',
        list: [{
          name: '保险名称'
        }, {
          name: '生效时间'
        }, {
          name: '到期时间'
        }]
      }, {
        name: '投保人信息',
        list: [{
          name: '投保人姓名'
        }, {
          name: '投保人生日'
        }, {
          name: '投保人证件类型'
        }, {
          name: '投保人证件号码'
        }, {
          name: '手机号码'
        }]
      }, {
        name: '被保险人信息',
        list: [{
          name: '被保险人姓名'
        }, {
          name: '被保险人生日'
        }, {
          name: '被保险人证件类型'
        }, {
          name: '被保险人证件号码'
        }, {
          name: '手机号码'
        }]
      }],
      arr: [{
        name: '受益人信息',
        list: [{
          name: '受益人类型'
        }]
      }]
    };
  }
};